import { z } from "zod";
import { EMAIL, PASSWORD } from "./consts";

export const schema = z.object({
  [EMAIL]: z.string().min(1, "Invalid Username"),
  [PASSWORD]: z.string().min(8, "Invalid Password"),
});

export type formValues = z.infer<typeof schema>;
